module.exports = __webpack_public_path__ + "static/media/luggage-small.9cc029aa.gif";